import qs, { ParsedQuery } from "query-string";

export const setQueryStringWithoutPageReload = (qsValue: string): void => {
    const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + qsValue;
    window.history.pushState({ path: newurl }, "", newurl);
};

export const resetQueryString = () => {
    setQueryStringWithoutPageReload("");
};

export const setQueryStringValue = (key: string, value: string, queryString = window.location.search): void => {
    const values = qs.parse(queryString);
    const newQsValue = qs.stringify({ ...values, [key]: value });
    setQueryStringWithoutPageReload(`?${newQsValue}`);
};

export const getQueryString = (queryString = window.location.search): ParsedQuery => {
    const values = qs.parse(queryString);
    return values;
};

export const getQueryStringValue = (
    key: string,
    queryString = window.location.search
): string | Array<string> | null => {
    const values = qs.parse(queryString);
    return values[key];
};

export const getQueryStringFilters = (queryString = window.location.search) => {
    const values = getQueryString(queryString);
    const filters: HashMap<string | Array<string> | null> = {};
    Object.keys(values).forEach((name: string) => {
        if (name.match(/^filter_/)) {
            filters[name] = values[name];
        }
    });
    return filters;
};
